'use client'
import React, { useState } from 'react';
import VideoModal from '../videoModel';
import ApplyNow from '@/ui/ApplyNow';
import Image from "next/image";
import Img1 from "@/assets/life/img-2.png";
import Img2 from "@/assets/life/img-3.png";
import Img3 from "@/assets/life/img-4.png";
import Img4 from "@/assets/life/img-5.png";
import sportImg1 from "@/assets/sports/sports-1.webp";
import sportImg2 from "@/assets/sports/sports-2.webp";
import sportImg3 from "@/assets/sports/sports-3.webp";
import sportImg4 from "@/assets/sports/sports-4.webp";
import sportImg5 from "@/assets/sports/sports-5.webp";
import sportImg6 from "@/assets/sports/sports-6.webp";
import sportImg7 from "@/assets/sports/sports-7.webp";
import sportImg8 from "@/assets/sports/sports-8.webp";
import sportImg9 from "@/assets/sports/sports-9.webp";
import sportImg10 from "@/assets/sports/sports-10.webp";


import { Play } from "lucide-react";

const Sports = () => {
    const [modal, setModal] = useState({ open: false, url: "" });

    const mediaData = [
        // {
        //     type: "video",
        //     img: 'https://cdn.msu.edu.in/from-campus/Sports.webp',
        //     alt: "Chancellor",
        //     videoUrl:
        //         "https://cdn.msu.edu.in/msu-reavamp/videos/Mr.+Pravesh+Dudani+Final.mp4",
        // },
        // { type: "image", img: Img1, alt: "Rank" },
        // { type: "image", img: Img2, alt: "Event 1" },
        // { type: "image", img: Img3, alt: "Group" },
        // { type: "image", img: Img4, alt: "Event 2" },
    ];

    const sportsData = [
        { img: sportImg1, alt: 'sports-1' },
        { img: sportImg2, alt: 'sports-2' },
        { img: sportImg3, alt: 'sports-3' },
        { img: sportImg4, alt: 'sports-4' },
        { img: sportImg5, alt: 'sports-5' },
        { img: sportImg6, alt: 'sports-6' },
        { img: sportImg7, alt: 'sports-7' },
        { img: sportImg8, alt: 'sports-8' },
        { img: sportImg9, alt: 'sports-9' },
        { img: sportImg10, alt: 'sports-1o' },

    ]

    const imageWrapperClasses = "relative w-full h-full overflow-hidden group";

    return (
        <>
            <VideoModal
                open={modal.open}
                url={modal.url}
                onClose={() => setModal({ open: false, url: "" })}
            />
            <section className="w-full flex justify-center">
                <div className="max-w-[var(--max-page-width)] w-full px-[var(--container-padding)] my-4 sm:my-8 md:my-14 lg:my-20">
                    <h2 className="font-extrabold text-[clamp(20px,3vw,42px)] text-black leading-normal mb-2">
                       Where Commitment Shapes Champions
                    </h2>

                    <p className="text-base md:text-lg mb-6">
                        At Medhavi Skills University, we believe in nurturing not just the mind, but the body and spirit as well. Our dynamic sports
                        facility provides students with the resources and opportunities they need to thrive both inside and outside the classroom.
                        Spanning an impressive 20,000 square feet, this state-of-the-art facility is designed to cater to the diverse interests
                        and passions of our students.
                    </p>

                    <p className="text-base md:text-lg mb-6">Within our meticulously crafted sports arena, you'll discover a plethora of courts
                        dedicated to a variety of sports, including volleyball, badminton, futsal, and basketball, among others.
                        Step indoors and explore our array of recreational opportunities, where you can engage in games like table
                        tennis, chess, or carom. With options to suit every interest and inclination, there's no shortage of ways to
                        stay active and engaged on campus.</p>

                    <div className="grid grid-cols-1 lg:grid-cols-[1.8fr_2fr] gap-2 md:gap-4 bg-white">

                        {mediaData.slice(0, 1).map((item, index) => (
                            <div key={index}
                                className="relative overflow-hidden shadow-md group"
                            >
                                <Image
                                    src={item.img}
                                    alt={item.alt}
                                    width={1000}
                                    height={1000}
                                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                />

                                {item.videoUrl && (
                                    <div className="absolute inset-0 flex items-center justify-center z-20">
                                        <button
                                            onClick={() =>
                                                setModal({
                                                    open: true,
                                                    url: item.videoUrl,
                                                })
                                            }
                                            className="flex justify-center items-center cursor-pointer w-14 h-14 sm:w-16 sm:h-16 rounded-full
                                            bg-white backdrop-blur text-[#081E2D] p-4 shadow-lg hover:scale-105 transition"
                                        >
                                            <Play className="w-6 h-6 ml-[1px]" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        ))}

                        <div className="grid grid-cols-2 grid-rows-2 gap-2 md:gap-4 overflow-hidden">
                            {mediaData.slice(1).map((item, index) => (
                                <div
                                    key={index}
                                    className="relative overflow-hidden shadow-md group"
                                >
                                    <Image
                                        src={item.img}
                                        alt={item.alt}
                                        className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-110"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>


                    <div className="mt-2 md:mt-4">
                        <div className="
                            grid grid-cols-2 gap-2 md:gap-4 w-full
                            sm:grid-cols-4
                            md:grid-cols-6 md:grid-rows-3
                            md:aspect-[16/9]"
                        >
                            <div className={`${imageWrapperClasses} aspect-4/3 md:aspect-auto md:col-span-2 md:row-span-1`}>
                                <Image src={sportsData[0].img} alt={sportsData[0].alt} fill className="object-cover transition-transform duration-700 hover:scale-110" />
                            </div>

                            <div className={`${imageWrapperClasses} aspect-4/3 md:aspect-auto md:col-span-2 md:row-span-2`}>
                                <Image src={sportsData[3].img} alt={sportsData[3].alt} fill className="object-cover transition-transform duration-700 hover:scale-110" />
                            </div>

                            <div className={`${imageWrapperClasses} aspect-4/3`}>
                                <Image src={sportsData[4].img} alt={sportsData[4].alt} fill className="object-cover transition-transform duration-700 hover:scale-110" />
                            </div>

                            <div className={`${imageWrapperClasses} aspect-4/3`}>
                                <Image src={sportsData[5].img} alt={sportsData[5].alt} fill className="object-cover transition-transform duration-700 hover:scale-110" />
                            </div>

                            <div className={`${imageWrapperClasses} aspect-4/3`}>
                                <Image src={sportsData[6].img} alt={sportsData[6].alt} fill className="object-cover transition-transform duration-700 hover:scale-110" />
                            </div>

                            <div className={`${imageWrapperClasses} aspect-4/3`}>
                                <Image src={sportsData[7].img} alt={sportsData[7].alt} fill className="object-cover transition-transform duration-700 hover:scale-110" />
                            </div>

                            <div className={`${imageWrapperClasses} aspect-4/3 md:aspect-auto md:col-span-2`}>
                                <Image src={sportsData[8].img} alt={sportsData[8].alt} fill className="object-cover transition-transform duration-700 hover:scale-110" />
                            </div>

                            <div className={`${imageWrapperClasses} aspect-4/3`}>
                                <Image src={sportsData[9].img} alt={sportsData[9].alt} fill className="object-cover transition-transform duration-700 hover:scale-110" />
                            </div>


                            <div className={`${imageWrapperClasses} aspect-4/3`}>
                                <Image src={sportsData[6].img} alt={sportsData[6].alt} fill className="object-cover transition-transform duration-700 hover:scale-110" />
                            </div>

                            <div className={`${imageWrapperClasses} aspect-4/3`}>
                                <Image src={sportsData[2].img} alt={sportsData[2].alt} fill className="object-cover transition-transform duration-700 hover:scale-110" />
                            </div>

                            <div className={`${imageWrapperClasses} aspect-4/3`}>
                                <Image src={sportsData[4].img} alt={sportsData[4].alt} fill className="object-cover transition-transform duration-700 hover:scale-110" />
                            </div>

                            <div className={`${imageWrapperClasses} aspect-4/3`}>
                                <Image src={sportsData[2].img} alt={sportsData[2].alt} fill className="object-cover transition-transform duration-700 hover:scale-110" />
                            </div>

                            <div className={`${imageWrapperClasses} aspect-4/3`}>
                                <Image src={sportsData[6].img} alt={sportsData[6].alt} fill className="object-cover transition-transform duration-700 hover:scale-110" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            <ApplyNow />
        </>
    )
}

export default Sports